"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataImportApiImpl = void 0;
const DataImportInternalApi_1 = require("../Internal/DataImportInternalApi");
const ApiBase_1 = require("./ApiBase");
class DataImportApiImpl extends ApiBase_1.ApiBase {
    constructor(adaptable) {
        super(adaptable);
        this.internalApi = new DataImportInternalApi_1.DataImportInternalApi(adaptable);
    }
    openImportWizard() { }
    importData(partialRows) { }
}
exports.DataImportApiImpl = DataImportApiImpl;
